import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import ComplementaryActivityEvaluationViewDefault from './Default';
import ComplementaryActivityEvaluationViewPlayful from './Playful';

export function ComplementaryActivityEvaluationView(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <ComplementaryActivityEvaluationViewPlayful {...props} /> : <ComplementaryActivityEvaluationViewDefault {...props} />;
}
